export const TripConstructionMethod = {
    Motion: 0,
    Stops: 1
}
